import { WidgetType } from 'widgets/WidgetType';
import { Action } from 'store/store';
import { WidgetActionType } from '../actions';
import { WidgetsSharedConfigState } from 'widgets/store/sharedConfiguration/WidgetsSharedConfigState';

export interface WidgetSetSharedConfigPayload<TSharedConfig> {
    widgetType: WidgetType;
    configDelta: Partial<TSharedConfig>;
}

/*
 * Action for configuration shared across all instances of a widget type
 */
export type WidgetSetSharedConfigAction<T> = Action<
    WidgetActionType.WIDGET_SET_SHARED_CONFIG,
    WidgetSetSharedConfigPayload<T>
>;

export function createUpdateWidgetSharedConfigurationAction<T>(
    widgetType: WidgetType,
    configDelta: Partial<T>
): WidgetSetSharedConfigAction<T> {
    return {
        type: WidgetActionType.WIDGET_SET_SHARED_CONFIG,
        payload: { widgetType, configDelta },
    };
}

export type WidgetLoadSharedConfigsAction = Action<
    WidgetActionType.WIDGET_LOAD_SHARED_CONFIGS,
    WidgetsSharedConfigState
>;

export function createWidgetLoadSharedConfigsAction(
    config: WidgetsSharedConfigState
): WidgetLoadSharedConfigsAction {
    return {
        type: WidgetActionType.WIDGET_LOAD_SHARED_CONFIGS,
        payload: config,
    };
}
